import { useEffect } from 'react';
import { useMapContext } from 'widgets/choroplethMap/contexts/mapContext';
import CHOROPLETH_STYLES from 'widgets/choroplethMap/constants/choroplethConstants';
import usePolygonHover from './usePolygonHover';
import useIsVisible from './useIsVisible';
import useChoroplethFillColor from './useChoroplethFillColor';
import getChoroplethParentLayer from 'widgets/choroplethMap/helpers/getChoroplethParentLayer';

// source-layers: countries, admin1

export default function usePolygonLayer({
	sourceName,
	layerName,
	sourceLayer,
	minzoom,
	maxzoom,
}: {
	sourceName: string;
	layerName: string;
	sourceLayer: string;
	minzoom: number;
	maxzoom: number;
}) {
	const [{ map }] = useMapContext();

	useEffect(() => {
		if (!map) return;
		map.addLayer(
			{
				id: layerName,
				type: 'fill',
				source: sourceName,
				'source-layer': sourceLayer,
				layout: {},
				paint: {
					'fill-color': 'blue',
					'fill-opacity': CHOROPLETH_STYLES.OPACITY.DEFAULT,
				},
				minzoom,
				maxzoom,
			},
			getChoroplethParentLayer({ layerName })
		);
	}, [map, sourceName, layerName, maxzoom, minzoom, sourceLayer]);

	usePolygonHover({ layerName: layerName, sourceName: sourceName, minzoom, maxzoom });
	useIsVisible({ layerName });
	useChoroplethFillColor({ sourceName, layerName });
}
